import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <g fill="currentColor" clipPath={`url(#${id})`}>
        <path d="M9 2c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0-2a9 9 0 1 0 .001 18.001A9 9 0 0 0 9 0" />
        <path d="M11.98 11.98c-.12-.55-.43-1.82-.56-2.36-.22-.78-.25-1.42-.59-2.07-.51-.61-.95-.68-1.7-1.15-.7-.4-1.6-.92-2.25-1.28-.25-.16-.54-.2-.75.02-.3.47.01.95.06 1.57.08.48.13.77.21 1.24.34 2.16.2 2.48 2.39 3.41.59.28.71.35 1.43.69.58.25 1.65 1.03 1.76.02v-.09M8.83 9.4c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63" />
      </g>
      <defs>
        <clipPath id={id}>
          <path fill="currentColor" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
